import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const CHAIR_ROOM_UTILIZATION_FILTERS = REPORTS_DEFAULT_FILTERS

export const CHAIR_ROOM_UTILIZATION_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'number' | 'decimal' | 'percent'
}> = [
  {
    id: 'chair-time-used',
    title: 'Chair Time Used',
    footer: 'Used',
    format: 'number',
  },
  {
    id: 'chair-rooms-used',
    title: 'Chair Rooms Used',
    footer: 'Available',
    format: 'number',
  },
  {
    id: 'avg-rooms-used',
    title: 'Avg. Rooms Used',
    footer: 'Per day',
    format: 'decimal',
  },
  {
    id: 'avg-room-operations',
    title: 'Avg. Room Operations',
    footer: 'Per Day',
    format: 'decimal',
  },
  {
    id: 'utilization-rate',
    title: 'Utilization Rate',
    footer: 'Used / Available',
    format: 'percent',
  },
]

/** @deprecated Use CHAIR_ROOM_UTILIZATION_KPI_DEFINITIONS with live API values */
export const CHAIR_ROOM_UTILIZATION_KPI_METRICS =
  CHAIR_ROOM_UTILIZATION_KPI_DEFINITIONS.map((def) => ({
    id: def.id,
    title: def.title,
    footer: def.footer,
    value: '—',
  }))

export type ChairTimeUsedRow = {
  month: string
  /** Minutes of chair time actually used. */
  used: number
  /** Minutes of total chair capacity available. */
  available: number
}

/** @deprecated Preview/PDF mock only */
export const CHAIR_TIME_USED_DATA: ChairTimeUsedRow[] = [
  { month: 'Dec', used: 3500, available: 2600 },
  { month: 'Jan', used: 3600, available: 3000 },
  { month: 'Feb', used: 3300, available: 3000 },
  { month: 'Mar', used: 3500, available: 2400 },
]

export type RoomUtilizationRow = {
  month: string
  /** Average number of rooms used per day. */
  avgUsed: number
  /** Total rooms available (operatories). */
  avgAvailable: number
}

/** @deprecated Preview/PDF mock only */
export const ROOM_UTILIZATION_DATA: RoomUtilizationRow[] = [
  { month: 'Dec', avgUsed: 5.0, avgAvailable: 8.0 },
  { month: 'Jan', avgUsed: 5.1, avgAvailable: 8.0 },
  { month: 'Feb', avgUsed: 5.0, avgAvailable: 8.0 },
  { month: 'Mar', avgUsed: 5.6, avgAvailable: 8.0 },
]

export type ProvidersWorkingRow = {
  month: string
  /** Average providers working per day. */
  providers: number
}

/** @deprecated Preview/PDF mock only */
export const PROVIDERS_WORKING_DATA: ProvidersWorkingRow[] = [
  { month: 'Dec', providers: 3.3 },
  { month: 'Jan', providers: 3.0 },
  { month: 'Feb', providers: 3.2 },
  { month: 'Mar', providers: 2.9 },
]

export type UtilizationRateRow = {
  month: string
  /** Utilization rate expressed as a percentage (0–100). */
  rate: number
}

/** @deprecated Preview/PDF mock only */
export const UTILIZATION_RATE_DATA: UtilizationRateRow[] = [
  { month: 'Dec', rate: 85.33 },
  { month: 'Jan', rate: 81.5 },
  { month: 'Feb', rate: 75.9 },
  { month: 'Mar', rate: 66.9 },
]
